/**
 * @generated SignedSource<<7dde99feda52c7a87e5fbecf0555670e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ExcludedIPListTabContainer_deleteMutation$variables = {
  connections: ReadonlyArray<string>;
  excludedIpAddressId: string;
};
export type ExcludedIPListTabContainer_deleteMutationVariables = ExcludedIPListTabContainer_deleteMutation$variables;
export type ExcludedIPListTabContainer_deleteMutation$data = {
  readonly deleteExcludedIpAddress: {
    readonly deletedExcludedIpAddressId: string;
  } | null;
};
export type ExcludedIPListTabContainer_deleteMutationResponse = ExcludedIPListTabContainer_deleteMutation$data;
export type ExcludedIPListTabContainer_deleteMutation = {
  variables: ExcludedIPListTabContainer_deleteMutationVariables;
  response: ExcludedIPListTabContainer_deleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludedIpAddressId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "excludedIpAddressId",
        "variableName": "excludedIpAddressId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedExcludedIpAddressId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExcludedIPListTabContainer_deleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteExcludedIpAddressPayload",
        "kind": "LinkedField",
        "name": "deleteExcludedIpAddress",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExcludedIPListTabContainer_deleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteExcludedIpAddressPayload",
        "kind": "LinkedField",
        "name": "deleteExcludedIpAddress",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedExcludedIpAddressId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f0e78cbb0e3d332997368024a888b644",
    "id": null,
    "metadata": {},
    "name": "ExcludedIPListTabContainer_deleteMutation",
    "operationKind": "mutation",
    "text": "mutation ExcludedIPListTabContainer_deleteMutation(\n  $excludedIpAddressId: ID!\n) {\n  deleteExcludedIpAddress(input: {excludedIpAddressId: $excludedIpAddressId}) {\n    deletedExcludedIpAddressId\n  }\n}\n"
  }
};
})();

(node as any).hash = "76c5a22661ff8fb2e4ee3df61a9c571f";

export default node;
